import { useAuth } from "hooks/useAuth";
import { useAppSelector } from "hooks/useRedux";
import mixpanel from "mixpanel-browser";
import { RootState } from "store";

const useMixpanel = () => {
  const authContext = useAuth();
  const businessState = useAppSelector((state: RootState) => state.businesses);

  const trackEvent = (name: string, options?: any) => {
    // Check if Mixpanel is properly initialized and has a valid token
    if (
      !process.env.REACT_APP_MIXPANEL_TOKEN ||
      process.env.REACT_APP_MIXPANEL_TOKEN === ""
    ) {
      console.warn("Mixpanel token not configured, skipping event tracking");
      return;
    }

    try {
      mixpanel?.track(`bwp-${name}`, {
        userId: authContext?.user?.uuid,
        businessId: businessState?.business?.uuid,
        ...options,
      });
    } catch (error) {
      console.error("Error tracking Mixpanel event:", error);
    }
  };

  return { trackEvent };
};

export default useMixpanel;
